// extracted by mini-css-extract-plugin
export default {"edit-btn":"ProfileAvatar_edit-btn__Tq7Rf","pen-icon":"ProfileAvatar_pen-icon__kHACd"};